import api from "@/lib/api";
import type {
  ApiTheme,
  ThemeCreationPayload,
  ThemesListParams,
} from "../types";
import type { PaginatedQueryResult } from "@/types";

const THEMES_ENDPOINTS = {
  LIST: "/topics/",
  GET_ONE: (id: string) => `/topics/${id}/`,
  CREATE: "/topics/",
  UPDATE: (id: string) => `/topics/${id}/`,
  DELETE: (id: string) => `/topics/${id}/`,
  BULK_UPDATE: "/topics/bulk_update/",
  BULK_DESTROY: "/topics/bulk_destroy/",
};

export class ThemesHttpRepository {
  async fetchList(
    params?: ThemesListParams,
  ): Promise<PaginatedQueryResult<ApiTheme>> {
    const result = await api.get(THEMES_ENDPOINTS.LIST, { params });
    return result.data;
  }
  async fetchOne(id: string): Promise<ApiTheme> {
    const result = await api.get(THEMES_ENDPOINTS.GET_ONE(id));
    return result.data;
  }
  async create(payload: ThemeCreationPayload): Promise<ApiTheme> {
    const result = await api.post(THEMES_ENDPOINTS.CREATE, payload);
    return result.data;
  }
  async update(id: string, payload: ThemeCreationPayload): Promise<ApiTheme> {
    const result = await api.put(THEMES_ENDPOINTS.UPDATE(id), payload);
    return result.data;
  }
  async patch(
    id: string,
    payload: Partial<ThemeCreationPayload>,
  ): Promise<ApiTheme> {
    const result = await api.patch(THEMES_ENDPOINTS.UPDATE(id), payload);
    return result.data;
  }
  async delete(id: string) {
    const result = await api.delete(THEMES_ENDPOINTS.DELETE(id));
    return result.data;
  }
  async bulkUpdate(payload: { id: string; status: string }[]) {
    const result = await api.patch(THEMES_ENDPOINTS.BULK_UPDATE, payload);
    return result.data;
  }
  async bulkDestroy(payload: { id: string }[]) {
    const result = await api.delete(THEMES_ENDPOINTS.BULK_DESTROY, {
      data: payload,
    });
    return result.data;
  }
}
